import { request } from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'

export const getOrderConfirm = async ({
  commit, state
}) => {
  const res = await request(API.ORDER_CONFIRM, 'POST', {})
  if (res && res.success) {
    commit(types.ORDER_DETAIL, res)
  }
  return res
}

export const getOrderDetail = async ({
  commit, state
}, { orderId }) => {
  const res = await request(`${API.ORDER_DETAIL}/${orderId}`, 'POST', {})
  if (res && res.success) {
    commit(types.ORDER_DETAIL, res)
  }
  return res
}

export const deletePerform = async ({
  commit, state
}, { sessionId, orderId }) => {
  const res = await request(API.DELETE_PERFORM, 'POST', {
    sessionId,
    orderId
  })
  if (res && res.success) {
    const deletedPerforms = state.performs.filter((perform) => {
      return perform.sessionId !== sessionId
    })
    commit(types.DELETE_PERFORM, deletedPerforms)
  }
  return res
}

export const clearOrder = ({ commit }) => {
  commit(types.CLEAR_ORDER)
}



// WEBPACK FOOTER //
// ./src/store/order/actions.js